import dayjs from "dayjs"
import { dateTimeFunction } from "utils/date"

const mortgageAssessmentDataInitialValues = (lead, data, projectId, inputType, updateMortgageProfile) => {
  return {
    projectId:
      lead?.projectId?.toString() ||
      data?.projectId?.toString() ||
      ((lead?.inquiry?.interestedIn === "primary" || data?.propertyType === "primary") && projectId?.toString()) ||
      null,
    listingId: lead?.listingId || data?.listingId || null,
    unitPrice: lead?.unitPrice || data?.snapshot?.dealPrice,
    salary: data?.salary,
    totalLiabilities: data?.totalLiabilities,
    nationalityId: data?.nationalityId,
    isFirstHome: data?.isFirstHome?.toString(),
    downPayment: {
      value: (lead?.unitPrice || data?.snapshot?.dealPrice) * 0.01 * (lead?.cdp || data?.cdpCommitment),
      percentage: lead?.cdp || data?.cdpCommitment,
      inputType: inputType,
    },
    eligibleMonthlyInstallment: data?.eligibleMonthlyInstallment || data?.snapshot?.eligibleMonthlyInstallment,
    tenor: data?.tenor || 25,
    occupationType: data?.employmentTypeId,
    dateOfBirth: data?.dateOfBirth ? dateTimeFunction({ date: data?.dateOfBirth, Default: true }) : null,
    propertyType: data?.propertyType,
    unitType: data?.unitTypeId,
    interestedCity: data?.interestedCityId?.toString(),
    updateMortgageProfile: updateMortgageProfile ?? true,
    assessments: data?.assessmentId,
    leads: data?.inquiryId,
    preferredUnitConstructionPhase: data?.construction,
  }
}

export default mortgageAssessmentDataInitialValues
